import { Box, Button, Stack } from "@mui/material";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import { ReactElement, useState } from "react";
import React from "react";
import { CustomTextView } from "../../component/CustomTextView";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { useLocation, useNavigate } from "react-router-dom";

export interface DrawerItem {
  isRoute: boolean;
  title: string;
  icon: ReactElement;
  onClick?: () => void;
  isSelected?: boolean;
  href?: string;
  textColor?: string;
  bgColor?: string;
  onCloseDrawer?: () => void;
}

export function DrawerItemView(props: DrawerItem) {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() == "rtl";

  const borderRadius = 45;

  const textColor = props.textColor ?? "lightGray";

  const navigate = useNavigate();
  const location = useLocation();

  const [invertedBorderVisible, setInvertedBorderVisible] = useState(true);
  return (
    <Stack>
      <Button
        key={props.title}
        sx={{
          transition: "all 0.3s ease-in-out",
          background: props.isRoute
            ? props.isSelected
              ? COLOR_WHITE
              : "rgba(135,40,77,0.35)"
            : props.bgColor,
          paddingTop: 2,
          paddingBottom: 2,
          paddingLeft: 4,
          paddingRight: 4,
          marginLeft: isRtl ? (props.isSelected ? 0 : 2) : 2,
          marginTop: 1,
          marginRight: isRtl ? 2 : props.isSelected ? 0 : 2,
          borderTopLeftRadius: isRtl
            ? props.isSelected
              ? 0
              : borderRadius
            : borderRadius,
          borderTopRightRadius: isRtl
            ? borderRadius
            : props.isSelected
            ? 0
            : borderRadius,
          borderBottomLeftRadius: isRtl
            ? props.isSelected
              ? 0
              : borderRadius
            : borderRadius,
          borderBottomRightRadius: isRtl
            ? borderRadius
            : props.isSelected
            ? 0
            : borderRadius,
          boxShadow: props.isSelected ? 12 : 0,
          "&:hover": {
            backgroundColor: props.isSelected ? "white" : "rgba(135,40,77,0.1)",
            boxShadow: 4,
            "@media (hover: none)": {
              backgroundColor: props.isRoute
                ? props.isSelected
                  ? COLOR_WHITE
                  : "rgba(135,40,77,0.35)"
                : props.bgColor,
            },
          },
          "& .MuiTouchRipple-child": {
            backgroundColor: COLOR_LESS_BLACK,
          },
        }}
        onClick={
          props.isRoute
            ? () => {
                if (location.pathname === props.href) return;
                window.scrollTo(0, 0)
                navigate(props.href!);
                setInvertedBorderVisible(false);
                setTimeout(() => {
                  setInvertedBorderVisible(true);
                  if (props.onCloseDrawer != undefined) props.onCloseDrawer();
                }, 300);
              }
            : props.onClick
        }
        LinkComponent={"a"}
      >
        <Stack direction={"row"} display={"flex"} flex={1}>
          {React.Children.map(props.icon, (child) => {
            return React.cloneElement(child, {
              sx: { color: props.isSelected ? COLOR_MAIN : textColor },
            });
          })}
          <Box width={12} />
          <CustomTextView
            text={props.title}
            textColor={props.isSelected ? COLOR_MAIN : textColor}
            props={{ textTransform: "none" }}
            fontWeight={props.isSelected ? "bold" : "normal"}
          />
        </Stack>
      </Button>

      {props.isSelected && invertedBorderVisible && (
        <Box
          sx={{
            width: 20,
            height: 20,
            position: "absolute",
            right: isRtl ? undefined : -6.5,
            left: isRtl ? -6.5 : undefined,
            marginTop: -1.4,
            borderBottomRightRadius: isRtl ? 0 : 60,
            borderBottomLeftRadius: isRtl ? 60 : 0,
            boxShadow: isRtl ? "-5px 5px 0 0 white" : "5px 5px 0 0 white",
          }}
        />
      )}

      {props.isSelected && invertedBorderVisible && (
        <Box
          sx={{
            width: 20,
            height: 20,
            position: "absolute",
            right: isRtl ? undefined : -6.5,
            left: isRtl ? -6.5 : undefined,
            marginTop: 7.9,
            borderTopRightRadius: isRtl ? 0 : 60,
            borderTopLeftRadius: isRtl ? 60 : 0,
            boxShadow: isRtl ? "-5px -5px 0 0 white" : "5px -5px 0 0 white",
          }}
        />
      )}
    </Stack>
  );
}
